module.exports = __webpack_public_path__ + "static/desktop-8d17b9ebfc405f21256906e75becda60.jpg";